export default __webpack_public_path__ + "static/media/aastha.973b6ac7.jpeg";